import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n/index.js';
var WarzoneI18NProvider = function WarzoneI18NProvider(_ref) {
  var children = _ref.children,
    language = _ref.language;
  useEffect(function () {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language]);
  return /* @__PURE__ */jsx(I18nextProvider, {
    i18n: i18n,
    children: children
  });
};
export { WarzoneI18NProvider };